module.exports = __webpack_public_path__ + "static/media/image.e89b6b3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/ConsumerBehaviour/image.jpg
// module id = 445
// module chunks = 0